import { Component, OnInit, ViewChild } from '@angular/core';
import { CategorySearchService } from 'src/app/_services/category-search.service';
import { CategorySearchData } from 'src/app/_models/category-search-data';
import { Router, NavigationEnd } from '@angular/router';
import { JwtHelperService } from "@auth0/angular-jwt";
import { CookieService } from '../../../../node_modules/ngx-cookie-service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material';
import { CustomDesignComponent } from 'src/app/custom-design/custom-design.component';





@Component({
    selector: 'app-site-header',
    templateUrl: './site-header.component.html',
    styleUrls: ['./site-header.component.css']
})
export class SiteHeaderComponent implements OnInit {
    helper = new JwtHelperService();
    categorySearchDataList: CategorySearchData[] = [];
    parentCategoryList = [];
    categoryNameList = [];
    objectKeys = Object.keys;
    categories = [];
    productSearchFormGroup: FormGroup
    subCategory = []
    userId: string;
    my_menu: {};
    // categoryId: any;
    categoryIdNew: any;
   


    constructor(
        private categorySearchService: CategorySearchService,
        private router: Router,
        private cookie: CookieService,
        private formBuilder: FormBuilder
    ) { //subscribes every changes of your route
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd){
               //scroll to top
               window.scrollTo(0,0);
            }
         }); }


    ngOnInit() {
        this.userId = ''
        this.getCategoriesWithParentCategories(this.userId)
        this.productSearchForm()
    }

    productSearchForm() {
        this.productSearchFormGroup = this.formBuilder.group({

            search: [''],
            category: ['']

        })
    }

    isToken() {
        var token = sessionStorage.getItem('token');
        if (token) {
            return true;
        }
        else {
            return false;
        }
    }
    /*-----Service call for getting all categories to be shown in product collection-------*/
    getCategoriesWithParentCategories(userId) {
        this.categorySearchService.getCategoryWithSubCategory(userId).subscribe(
            resp => {
                this.categorySearchDataList = resp as CategorySearchData[];
                this.categorySearchDataList.filter(categories => {
                    if (categories.categories != null) {
                        categories.categories.filter(element => {
                            if (element.subCategories != null) {
                                element.subCategories.filter(subCategory => {

                                    this.categories.push({ categoryName: element.categoryName, categoryId: element.categoryId, subCategories: [{ subcategoryName: subCategory.subCategoryName, categoryId: subCategory.categoryId }] })

                                })
                            }
                        });
                    }
                })
            });

    }

    /*---Method call for navigating to respective categories by passing categoryId and categoryName as parameter---*/
    categoryDetailsUrl(categoryId: any, categoryName: String) {
        this.cookie.set("categoryId", categoryId)
        this.router.navigate(['/category', categoryId, categoryName]);
    }

    onLogin(){
        this.router.navigate(['/login']);
    }

    onLogout() {
        sessionStorage.removeItem('token');
        this.cookie.deleteAll();
        this.router.navigate(['/login']);
        // localStorage.removeItem('loginDetails')
    }

    get currentUser() {
        let token = sessionStorage.getItem('token');
        if (!token) return null;

        return this.helper.decodeToken(token);

    }
    feedbackUrl(feedbackType) {
        this.router.navigate(['/contactUs', feedbackType]);
    }

    CustomDesign(){
        this.router.navigate(['/custom-design']);
        console.log(CustomDesignComponent)
      }
      
    selectedValue() {

        let searchKeyword = this.productSearchFormGroup.get('search').value;
        // this.categoryId = this.cookie.get("categoryId")
            this.router.navigate(['/productSearch', '', searchKeyword])
    }

    aboutUrl() {
        this.router.navigate(['/aboutus']);
    }

    homeUrl() {
        this.router.navigate(['/home']);
    }
}